// extracted by mini-css-extract-plugin
export default {"lifecycle-detail-page":"PropertyLifecycleDetailsPage_lifecycle-detail-page__p+7gN"};